import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HitotsuzuriHero from './components/HitotsuzuriHero';
import HitotsuzuriFeatures from './components/HitotsuzuriFeatures';
import HitotsuzuriDownload from './components/HitotsuzuriDownload';
import HitotsuzuriContact from './components/HitotsuzuriContact';

const HitotsuzuriPage = () => {
  usePageMeta({
    title: '一綴り（Hitotsuzuri）| 株式会社MSK',
    ogTitle: '一綴り（Hitotsuzuri） | 株式会社MSK',
    description: 'PDFの分割・抽出・結合ができるWindows向けデスクトップアプリ「一綴り（Hitotsuzuri）」の詳細ページです。個人・法人を問わず無料でご利用いただけます。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <HitotsuzuriHero />
        <HitotsuzuriFeatures />
        <HitotsuzuriDownload />
        <HitotsuzuriContact />
      </main>
      <Footer />
    </div>
  );
};

export default HitotsuzuriPage;